import React from "react";

const StorePage = () => {
  return (
    <div>
      <h1>Store Page</h1>
      <ev-engagement group-name="store" />
    </div>
  );
};

export { StorePage };
